import { ProFormaModelIds } from 'constants/proForma';
import { OperationsMetricId, OperationsRowKey } from './metrics';
import { SectionDescriptor, LayoutContext, RowDescriptor } from './types';

export const OPERATIONS_COLUMNS = ['Untrended', 'Trended', 'Sale'] as const;

type Columns = typeof OPERATIONS_COLUMNS;
type OperationsRow = RowDescriptor<OperationsMetricId, Columns>;

const trendingCells = (rowKey: OperationsRowKey, isNegative?: boolean): OperationsRow['cells'] => [
    { metric: `${rowKey}.untrended`, isNegative },
    { metric: `${rowKey}.trended`, isNegative },
    { metric: `${rowKey}.sale`, isNegative },
];

const valuationPerUnitRows = ({ proFormaModelId }: LayoutContext): OperationsRow[] => {
    if (proFormaModelId === ProFormaModelIds.APARTMENT) {
        return [{
            id: 'valuation-unit',
            label: 'Valuation / unit',
            className: 'pl-2',
            cells: trendingCells('valuationPerUnit'),
        }];
    }
    return [];
};

export const operationsLayout = (context: LayoutContext): SectionDescriptor<OperationsMetricId, Columns>[] => [
    {
        id: 'cash-flows-section',
        title: 'Cash flows',
        columns: OPERATIONS_COLUMNS,
        rows: [
            { id: 'effective-gross-revenue', label: 'Effective gross revenue', cells: trendingCells('effectiveGrossRevenue') },
            { id: 'operating-expenses', label: 'Operating expenses', cells: trendingCells('operatingExpenses', true) },
        ],
    },
    {
        id: 'net-operating-income-section',
        columns: OPERATIONS_COLUMNS,
        headers: 'none',
        rows: [
            { id: 'net-operating-income', label: 'Net operating income', cells: trendingCells('netOperatingIncome') },
            { id: 'capital-expenditures', label: 'Capital expenditures', cells: trendingCells('capitalExpenditures', true) },
        ],
    },
    {
        id: 'cash-flow-from-operations-section',
        columns: OPERATIONS_COLUMNS,
        headers: 'none',
        rows: [
            { id: 'cash-flow-operations', label: 'Cash flow from operations', cells: trendingCells('cashFlowFromOperations') },
            { id: 'cap-rate', label: 'Cap rate', cells: trendingCells('capRate') },
            { id: 'valuation', label: 'Valuation', cells: trendingCells('valuation') },
            {
                id: 'percent-of-total-project-cost',
                label: '% of total project cost',
                className: 'pl-2',
                cells: trendingCells('percentOfTotalProjectCost'),
            },
            ...valuationPerUnitRows(context),
        ],
    },
];
